import * as React from 'react';

import CreditModel from 'src/model/credit.model';

import './CreditsRowMobile.scss';
import RCheckbox from 'src/components/common/RCheckbox/RCheckbox';
import LocaleFormating from 'src/translation/localeFormating';

interface ICreditsRowMobileProps {
  credit: CreditModel;
  onShowDetails: (e: any, payment: any) => void;
  onChangeCheckbox: (payment: any) => void;
}

interface ICreditsRowMobileState {
  isChecked: boolean;
}
class CreditsRowMobile extends React.Component<
  ICreditsRowMobileProps,
  ICreditsRowMobileState
> {
  constructor(props: any) {
    super(props);

    this.state = {
      isChecked: false
    };
  }

  public componentDidMount = () => {
    const { credit } = this.props;

    if (credit.paymentStatus === 'VOID') {
      this.setState({
        isChecked: true
      });
    }
  };

  public render() {
    return (
      <div className="rp-credits-row-mobile row">
        <div className="col-4">
          <h6 className="rp-credits-row-mobile-header">Payment ID</h6>
          <a
            onClick={e => this.props.onShowDetails(e, this.props.credit)}
            href="#"
            className="rp-credits-row-mobile-content --tracking-number"
          >
            {this.props.credit.paymentId}
          </a>
        </div>
        <div className="col-4">
          <h6 className="rp-credits-row-mobile-header">PMT Time</h6>
          <span className="rp-credits-row-mobile-content">
            {LocaleFormating.formatDate(this.props.credit.pmtDate, 'short')}
          </span>
        </div>
        <div className="col-4">
          <h6 className="rp-credits-row-mobile-header">Actions</h6>
          <span className="rp-credits-row-mobile-content">
            <RCheckbox
              id={this.props.credit.paymentId}
              onChanged={
                this.props.credit.paymentStatus !== 'PENDING'
                  ? () => null
                  : () => this.props.onChangeCheckbox(this.props.credit)
              }
              color={
                this.props.credit.paymentStatus !== 'PENDING' ? 'gray' : 'green'
              }
              usesLabel={true}
              label={'VOID'}
              type={'box'}
              checked={this.state.isChecked}
              disabled={this.props.credit.paymentStatus !== 'PENDING'}
            />
          </span>
        </div>
      </div>
    );
  }
}

export default CreditsRowMobile;
